import { Injectable, signal } from '@angular/core';
import { FilterCustomersDto } from './dtos/filter-customers.dto';
import { CustomerI } from './interfaces/customer.interface';
import { FilterCustomerTransactionsDto } from './dtos/filter-customer-transactions.dto';

@Injectable({
  providedIn: 'root',
})
export class CustomersService {
  filterCustomers = signal<FilterCustomersDto | null>(null);

  filterCustomerTransactions = signal<FilterCustomerTransactionsDto | null>(
    null
  );

  selectedCustomer = signal<CustomerI | null>(null);

  isCustomerSideMenuCollapsed = signal<boolean>(false);
}
